module.exports = __webpack_public_path__ + "img/icon-01.304f167b.png";